import styled from "styled-components"

export const ManagerNameWrapper = styled.div`
  display: flex;
  > span {
    line-height: 16px;
    margin-left: 8px;
  }
`
